import { render, staticRenderFns } from "./Installations.vue?vue&type=template&id=54045127&"
import script from "./Installations.vue?vue&type=script&lang=js&"
export * from "./Installations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports